<script lang="ts">
	export let isMerch: boolean | undefined;
	import box from '$lib/assets/merch/Box2.svg';
	export let tooltip = true;
</script>

{#if isMerch && tooltip}
	<span
		class="tooltip tooltip-bottom tooltip-secondary inline-flex cursor-default items-center justify-center text-title3 text-base-content"
		data-tip="This NFT includes physical merchandise."
	>
		<img src={box} width={24} height={24} alt="Physical Merch" />
	</span>
{:else if isMerch}
	<img src={box} width={24} height={24} alt="Physical Merch" />
{/if}
